import axios from "axios";
import { SERVER_URL } from "../const";
import { D2D_API_URL, D2D_API_KEY } from "../const";


export const getReportConfigDetails = async (report_name) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${SERVER_URL}/report-templates/config?report_name=${report_name}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (response.status === 200) {
      const data = response.data;
      // console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
  }
};

export const getAllReportTemplatesByType = async (type_name, page = null, page_size = null, iec_no = null) => {
  try {
    const token = localStorage.getItem('token');
    let url = `${SERVER_URL}/report-templates/view?type_name=${type_name}`;
    if (page && page_size) {
      url += `&page=${page}&page_size=${page_size}`;
    }
    if (iec_no) {
      url += `&iec_no=${iec_no}`;
    }
    const response = await axios.get(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const getReportTemplateDetailsById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${SERVER_URL}/report-templates/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const addTemplate = async (payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(SERVER_URL + "/report-templates", payload,
      {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        },

      });

    if (response.status === 200) {
      const data = response.data;
      // console.log('API Response:', data);
      return data;
    } else {
      console.error('API Error:', response.statusText);
    }
  } catch (error) {
    console.error('Error:', error.message);
  }
};

export const UpdateTemplateDetails = async (id, payload) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${SERVER_URL}/report-templates/${id}`, payload, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const deleteTemplateDetails = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${SERVER_URL}/report-templates/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const triggerTemplateExport = async (template_id, iec_no, filters, include_fcc_columns = false) => {
  try {
    const token = localStorage.getItem('token');
    let queryParams = `template_id=${template_id}&from_date=${filters.from_date}&to_date=${filters.to_date}&iec_no=${iec_no}&include_fcc_columns=${include_fcc_columns}`
    const response = await axios.post(`${D2D_API_URL}/list-bills/download-all/template?${queryParams}`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'X-API-KEY': D2D_API_KEY
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  }
};

export const getFilterOptions = async (billType, sheetName, columnName, iec_no) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${SERVER_URL}/report-templates-filters`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        bill_type: billType,
        sheet_name: sheetName,
        column_name: columnName,
        iec: iec_no
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching filter options:', error);
    throw error;
  }
};